import { useEffect } from "react";
import { FB_PIXEL_ID } from "./fbpixel";

// Module-private flag: whether the Meta Pixel snippet has been injected during
// this page session. Persists across all component mounts/remounts (StrictMode
// double-invoke, route navigation), so we never inject twice.
let injected = false;

/**
 * Injects the Meta (Facebook) Pixel once per page load — production only, and
 * only when REACT_APP_FB_PIXEL_ID is set. Fully dormant otherwise. Pairs with
 * fireLead() in ./fbpixel, which records the Lead event on funnel completion.
 */
export default function FbPixelLoader() {
  useEffect(() => {
    if (!FB_PIXEL_ID) {
      if (process.env.NODE_ENV !== "production") {
        console.log("[fbpixel] disabled: REACT_APP_FB_PIXEL_ID not set");
      }
      return;
    }

    if (process.env.NODE_ENV !== "production") {
      console.log(
        "[fbpixel] dev mode: skipping script injection for pixel " + FB_PIXEL_ID
      );
      return;
    }

    // Primary guard: once injected in this page session, never inject again.
    if (injected) return;

    // Secondary guard: the pixel script may already be on the page.
    if (document.getElementById("fb-pixel")) {
      injected = true;
      return;
    }

    try {
      // Standard Meta Pixel snippet, run as an inline script so the snippet's
      // bare `fbq` resolves in global scope. The IIFE injects fbevents.js with
      // id="fb-pixel" so future mounts can detect it. FB_PIXEL_ID interpolated.
      const script = document.createElement("script");
      script.textContent =
        "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.id='fb-pixel';t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');" +
        "fbq('init', '" +
        FB_PIXEL_ID +
        "');fbq('track', 'PageView');";
      document.head.appendChild(script);

      injected = true;
    } catch (err) {
      // Non-fatal: if injection fails, pixel tracking is simply absent.
      console.log("[fbpixel] script injection failed", err);
    }
  }, []);

  return null;
}
